import searchMobileModal from './index.vue'

const Plugin = {
  install (Vue, options = {}) {
    if (this.installed) {
      return
    }
    this.installed = true
    this.event = new Vue()

    Vue.component(searchMobileModal.name, searchMobileModal)
    // Vue.mixin({
    // })
    Vue.prototype.$searchMobileModal = {
      toggle (bool) {
        Plugin.event.$emit('toggle', bool)
      },
      set (payload) {
        Plugin.event.$emit('set', payload)
      },
      submit () {
        Plugin.event.$emit('submit')
      }
      // focus (target) {
      //   Plugin.event.$emit('focus', target)
      // }
    }
  }
}

// This exports the plugin object.
export default Plugin
